import "./index.scss";
import checktxtImg from "@/assets/check_txt.png";
import { Link } from "react-router-dom";
function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-nav">
        <div className="baichang-logo-container">
          <div className="logo">
            <img
              src={require("../../assets/360logo-w.png")}
              className="logo-img"
            />
          </div>
          <div className="link-row">
            {" "}
            <a href="https://www.bcpai.com/yyzz" target="_blank">
              上海百昌科技集团有限公司
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="https://www.bcpai.com/jypzzs" target="_blank">
              拍卖经营许可证
            </a>
          </div>
          <div className="link-row">
            {" "}
            Copyright&nbsp;&nbsp;©2018-2023&nbsp;&nbsp;百昌拍卖.All rights
            reserved.
          </div>
          <div className="link-row">
            <a
              href="https://beian.miit.gov.cn/#/Integrated/index"
              target="_blank"
            >
              沪ICP备2021026343号-5
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {/* <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202007656"
              target="_blank"
            >
              沪公网安31011202007656号
            </a> */}
          </div>

          {/* https://www.bcpai.com/privacy */}
          {/* https://www.bcpai.com/conceal */}
          <div className="link-row">
            {" "}
            <a href="/userprotocol" target="_blank">
              用户协议
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="/pravicyprotocol" target="_blank">
              隐私协议
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </div>
          <div className="link-row">
            <a href="https://www.bcpai.com/aqzs" target="_blank">
              信息系统安全等级保护备案证明
            </a>
          </div>
        </div>
        <div className="product-container">
          <div className="product p-center">
            <div className="title title-line">产品中心</div>
            <div className="m-a">
              <a href="https://recheck.bczcc.com" target="_blank">
                再查查<span></span>
              </a>
            </div>
            <div className="m-a">
              <a href="https://www.bcpai.com" target="_blank">
                百昌拍卖<span></span>
              </a>
            </div>
            <div className="m-a">
              <a href="https://shiye.bczcc.com" target="_blank">
                师爷AI<span></span>
              </a>
            </div>
            <div className="m-a">
              <a href="https://www.bcyhl.com/" target="_blank">
                赢回来<span></span>
              </a>
            </div>
            {/* <div className="m-a">
              <a href="https://www.bcpai.com/meansShop" target="_blank"
              >资产小店<span></span
              ></a>
            </div> */}
            <div className="m-a">
              <a href="https://www.bcainpl.com/assessMap" target="_blank">
                百昌估值地图<span></span>
              </a>
            </div>
          </div>
          <div className="product p-center">
            <div className="title"></div>
            <div className="m-a">
              <a href="https://www.bcainpl.com/brief/" target="_blank">
                百昌找律师<span></span>
              </a>
            </div>
            <div className="m-a">
              <a href="https://shouxihome.bcainpl.com/" target="_blank">
                首席-特殊资产智能管理系统<span></span>
              </a>
            </div>
            <div className="m-a">
              <a href="https://www.bcainpl.com/steward/" target="_blank">
                百昌数字楼宇<span></span>
              </a>
            </div>
          </div>
          <div className="product">
            <div className="title title-line">联系我们</div>
            <div className="m-a">业务热线</div>
            <div className="m-a">400-015-0005</div>
            <div className="m-a">邮箱</div>
            <div className="m-a">recheck@bcnpl.com</div>
          </div>
        </div>
        <div className="contract-container">
          <div className="code-item">
            <div className="code-container">
              <img
                src={require("../../assets/gongzhonghao@3x.png")}
                className="code"
              />
            </div>
            <div className="text">扫码关注再查查公众号</div>
          </div>
          <div className="code-item">
            <div className="code-container">
              <img
                src={require("../../assets/contract@3x.png")}
                className="code"
              />
            </div>
            <div className="text">扫码联系再查查客服</div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Footer;
